import { jokesCollection } from '../storage/jokes';

const getRandomNumberInRange = (min, max) => {
  return Math.floor(Math.random() * (max - min) + min);
};

export const fetchRandomProgrammingJoke = () => {
  const numberOfJokes = jokesCollection.length;
  const randomIndex = getRandomNumberInRange(0, numberOfJokes);
  return jokesCollection[randomIndex];
};

export default {
  fetchRandomProgrammingJoke,
};
